<template>
  <Teleport to="body">
    <div 
      v-if="isOpen" 
      class="fixed inset-0 bg-black bg-opacity-75 z-[9999] overflow-y-auto"
      @click.self="closeModal"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0;"
    >
      <div class="min-h-screen flex items-start justify-center py-4 px-3 sm:px-4 md:px-6 sm:items-center sm:py-8">
        <div class="relative bg-black rounded-lg shadow-2xl w-full max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl xl:max-w-5xl max-h-[90vh] sm:max-h-[85vh] flex flex-col my-auto">
          <!-- Close Button -->
          <button 
            @click="closeModal" 
            class="absolute top-2 right-2 sm:top-4 sm:right-4 text-white hover:text-gray-300 z-10 bg-black bg-opacity-50 rounded-full p-1.5 sm:p-2 transition-colors"
            aria-label="Close video"
          >
            <svg class="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          
          <!-- Video Player -->
          <div class="relative w-full flex-shrink-0 rounded-lg overflow-hidden" style="padding-top: 56.25%">
            <video 
              ref="videoPlayer"
              class="absolute top-0 left-0 w-full h-full"
              controls
              autoplay
              preload="metadata"
              :poster="poster"
            >
              <source :src="videoSrc" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  videoSrc: {
    type: String,
    required: true
  },
  poster: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['close']);

const videoPlayer = ref(null);

const closeModal = () => {
  // Pause video when closing
  if (videoPlayer.value) {
    videoPlayer.value.pause();
  }
  emit('close');
};

// Close on Escape key
const handleEscape = (e) => {
  if (e.key === 'Escape' && props.isOpen) {
    closeModal();
  }
};

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    window.addEventListener('keydown', handleEscape);
  } else {
    window.removeEventListener('keydown', handleEscape);
  }
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleEscape);
});
</script>

<style scoped>
</style>

